module.exports = __webpack_public_path__ + "img/ic-sound.a3819d58.svg";